
import React      from 'react';
import CSSModules from 'react-css-modules';

import AdminSideBar from '../AdminSideBar';
import Header from '../Header';
import NotificationSystem from 'react-notification-system';
import Notifier from '../../services/notifier';
import authenticator from '../../services/authenticator';
import navigator from '../../services/navigator';
import colourCodes from '../../services/constants/colourCodes';

import style from './style.scss';

const notificationStyle = {
    NotificationItem: {
        DefaultStyle: {
            fontSize: '14px',
            padding: '15px',
            borderRadius: '0',
            border: 'none',
            boxShadow: '0px 0px 5px 3px rgba(0,0,0,0.40)'
        },
        success: {
            backgroundColor: colourCodes.primaryGreen,
            color: '#FFFFFF'
        },
        error: {
            backgroundColor: colourCodes.dangerBackground,
            color: '#FFFFFF'
        }
    },
    Dismiss: {
        DefaultStyle: {
            display: 'none'
        }
    },
    Containers: {
        DefaultStyle: {
            marginTop: '75px'
        }
    }
};

class Dashboard extends React.Component {

    _logout() {
        function logoutSuccess() {
            navigator.push('/login')
        }

        authenticator.logout().then(logoutSuccess);

    }

    render() {

        return (
            <article styleName="dashboard">

                <Header isDashboard={true}/>

                <AdminSideBar logout={this._logout.bind(this)}/>

                <NotificationSystem style={notificationStyle} ref={elem => Notifier.setNotifierElement(elem)} />

                <div styleName="content">
                    { this.props.children }
                </div>

            </article>
        );
    }
}

export default CSSModules(Dashboard, style);


// WEBPACK FOOTER //
// ./components/Dashboard/index.js